import { FC } from 'react';
import { useForm } from 'react-hook-form';

import {
  initCustomerFormFields,
  type CustomerFormFields,
} from 'page/CustomerPage/types/customerFormField';
import { useRegistrationStore } from 'page/CustomerPage/hooks';
import { InputModal } from './InputModal';
import { ConfirmationModal } from './ConfirmationModal';
import { ResultModal } from './ResultModal';

export const RegistrationModal: FC = () => {
  const {
    init: initRegistration,
    goInputModal,
    goConfirmationModal,
    setForm,
    postCustomerAndReload,
  } = useRegistrationStore();

  const { formState, register, getValues, reset, watch } =
    useForm<CustomerFormFields>({
      defaultValues: initCustomerFormFields,
      mode: 'all',
    });

  // 契約種別のフォームの値
  const watchChannel = watch('channel');
  const watchEnableVerticalPodAutoScaler = watch('enableVerticalPodAutoScaler');

  /**
   * モーダルを閉じたときにおこなう一連の初期化処理
   */
  const initState = () => {
    // フォームをリセット
    reset();
    // 登録画面の state を初期化
    initRegistration();
  };

  /**
   * 入力モーダル・確認モーダルで右上の「×」ボタンをクリックしたときの処理
   */
  const handleClose = () => {
    // 初期化
    initState();
  };

  /**
   * 入力モーダルで「確認」ボタンをクリックしたときの処理
   */
  const handleClickGoConfirmation = () => {
    // フォームの内容を state に保存
    setForm(getValues());
    // 確認モーダルに進む
    goConfirmationModal();
  };

  /**
   * 確認モーダルで「入力画面に戻る」ボタンをクリックしたときの処理
   */
  const handleClickGoInput = () => {
    // 入力モーダルに戻る
    goInputModal();
  };

  /**
   * 確認モーダルで「登録ボタン」をクリックしたときの処理
   */
  const handleClickRegistration = () => {
    // お知らせ登録処理＆一覧をリロード
    void postCustomerAndReload();
  };

  return (
    <>
      {/* 入力モーダルコンテナ */}
      <InputModal
        watchChannel={watchChannel}
        watchEnableVerticalPodAutoScaler={watchEnableVerticalPodAutoScaler}
        formState={formState}
        register={register}
        handleClose={handleClose}
        handleClickGoConfirmation={handleClickGoConfirmation}
      />
      {/* 確認モーダルコンテナ */}
      <ConfirmationModal
        handleClose={handleClose}
        handleClickGoInput={handleClickGoInput}
        handleClickRegistration={handleClickRegistration}
      />
      {/* 結果モーダルコンテナ */}
      <ResultModal handleClose={handleClose} />
    </>
  );
};
